import classNames from 'classnames'
import React from 'react'

import { css } from '@portal/styled-system/css'

import { useOutsideClick, useToggle } from '@/shared/lib/hooks'

type DropdownProps = {
    title: string
    titleClassName?: string
}

export function Dropdown({ title, titleClassName, children }: React.PropsWithChildren<DropdownProps>) {
    const menuRef = React.useRef(null)
    const [show, toggle] = useToggle(false)

    useOutsideClick(
        menuRef,
        React.useCallback(() => show && toggle(), [show, toggle])
    )

    return (
        <div
            className={css({
                position: 'relative',
            })}
            onClick={toggle}
            ref={menuRef}
        >
            <div role="button" className={titleClassName}>
                {title}
                <i
                    className={classNames(
                        `fa-solid fa-caret-${show ? 'down' : 'up'}`,
                        css({
                            fontSize: 'xs',
                            marginLeft: '1',
                        })
                    )}
                />
            </div>

            <div
                className={css({
                    display: show ? 'block' : 'none',
                    position: 'absolute',
                    bottom: 'full',
                    right: '0',
                    paddingX: '0',
                    paddingY: '2',
                    textAlign: 'start',
                    color: 'gray.600',
                    backgroundColor: 'white',
                    backgroundClip: 'padding-box',
                    border: 'tooltip',
                    borderRadius: 'md',
                })}
            >
                {children}
            </div>
        </div>
    )
}
